<template>
  <div
    v-if="is_permission_disabled"
    role="alert"
    class="alert alert-warning mb-2 has-checked:hidden"
  >
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>
      Cảnh báo: Tính năng này đã bị vô hiệu hóa! Để bật lại tính năng này, đi
      tới phần
      <RouterLink
        class="link font-bold"
        :to="{
          name: 'ClientSetting',
          query: {
            highlighted: permission,
          },
        }"
      >
        cài đặt
      </RouterLink>
      .
    </span>
    <label for="hide-warning" class="cursor-pointer">&#10799;</label>
    <input id="hide-warning" type="checkbox" class="peer hidden" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { type_str } from ".";
import { use_client_detail } from "./useClientDetail";

const client_detail_store = use_client_detail();
const is_permission_disabled = computed(() => {
  const tab = client_detail_store.tabs.find(
    (t) => t.be_mapping === props.permission,
  );

  return (
    tab &&
    Array.isArray(client_detail_store.client_detail?.permissions) &&
    !client_detail_store.client_detail.permissions?.some(
      (p) => p === tab.be_mapping,
    )
  );
});
const props = defineProps<{ permission: type_str }>();
</script>
